import angular, {ILogService, IPromise} from "angular";
import _ from "lodash";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";
import {Autentisering} from "felles/tjenester/Autentisering";
import {MeldingTilBruker, Varighet} from "../../../../../felles/tjenester/MeldingTilBruker";
import {gettextCatalog} from "angular-gettext";
import {GruppeDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";

const debug: Debugger = require('debug')('AutentiserMedHøyereSikkerhetsnivåKontroller');

require('./autentiserMedHøyereSikkerhetsnivå.scss');

export class AutentiserMedHøyereSikkerhetsnivåKontroller implements MdDialogController {

    /**
     * Viser modal dialog innloggingsskjema slik at bruker kan autentisere til et høyere nivå for å få tilgang til
     * grupper som krever dette.
     */
    static visAutentiserMedHøyereSikkerhetsnivå($mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show({
            template: require('./autentiserMedHøyereSikkerhetsnivå.html'),
            locals: {},
            controller: AutentiserMedHøyereSikkerhetsnivåKontroller.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true
        });
    }

    static forInjisering() {
        return [
            regNavn.ng.$log,
            regNavn.md.$mdDialog,
            Kontekst.regNavn,
            Autentisering.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            ng2RegNavn.GruppeDatatjenesteForAjs,
            AutentiserMedHøyereSikkerhetsnivåKontroller
        ]
    }

    constructor(private $log: ILogService,
                private $mdDialog: angular.material.IDialogService,
                private kontekst: Kontekst,
                private autentisering: Autentisering,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog,
                private gruppeDatatjeneste:GruppeDatatjenesteForAjs) {
    }

    metodeValgt = false;

    visCriiptovalg = false;
    visAktiverCriiptodialog = false;
    visCriiptodialog = false;

    visPassordvalg = false;
    visPassordvalgTotp = false;
    visPassordvalgSmsOtp = false;
    visAktiverTotpDialog = false;
    visAktiverSmsOtpDialog = false;
    visPassorddialog = false;

    criiptoGuiModus = l.CriiptoGuiModus.popup; //dersom vi velger noe annet enn popup må criipto callback håndteres på annet vis

    grupper: l.GruppeSomKreverAnnenAutentiseringsmetodeModell[];

    private tillatteMetoder: _.Collection<l.Autentiseringsmetode>;
    private aktiverteMetoder: _.Collection<l.Autentiseringsmetode>;

    aktiverPassorddialog(valgtOtp: 'totp'|'smsOtp' = null) {
        console.log("ValgtOtp:", valgtOtp);

        //målgruppe aksepterer totp og bruker har aktivert denne
        if (this.tillatteMetoder.includes(l.Autentiseringsmetode.totpOtp) && this.aktiverteMetoder.includes(l.Autentiseringsmetode.totpOtp))
            this.visPassorddialog = true;

        //målgruppe aksepterer smsOtp og bruker har aktivert denne
        else if (this.tillatteMetoder.includes(l.Autentiseringsmetode.smsOtp) && this.aktiverteMetoder.includes(l.Autentiseringsmetode.smsOtp))
            this.visPassorddialog = true;

        //målgruppe aksepterer begge otp metodene - men bruker har ikke aktivert noen av disse - bruker må velge en
        else if (_.isNil(valgtOtp) && this.tillatteMetoder.includes(l.Autentiseringsmetode.totpOtp) && this.tillatteMetoder.includes(l.Autentiseringsmetode.smsOtp)) {
            this.visPassordvalgTotp = true;
            this.visPassordvalgSmsOtp = true;
            this.visCriiptovalg = false;
            return; //bruker må nå velge om han vil aktivere totp eller smsOtp
        }

        //målgruppe aksepterer begge otp metodene - bruker har valgt hvilken han vil aktivere
        else if (valgtOtp == 'totp')
            this.visAktiverTotpDialog = true;
        //målgruppe aksepterer begge otp metodene - bruker har valgt hvilken han vil aktivere
        else if (valgtOtp == 'smsOtp')
            this.visAktiverSmsOtpDialog = true;

        //målgruppe aksepterer totp metodene - men bruker har ikke aktivert denne
        else if (this.tillatteMetoder.includes(l.Autentiseringsmetode.totpOtp))
            this.visAktiverTotpDialog = true;

        //målgruppe aksepterer smsOtp metodene - men bruker har ikke aktivert denne
        else if (this.tillatteMetoder.includes(l.Autentiseringsmetode.smsOtp))
            this.visAktiverSmsOtpDialog = true;


        this.metodeValgt = true;
    }

    aktiverCriiptodialog() {
        if (!_.includes(this.kontekst.autentisertBruker().autentiseringsmetoder, l.Autentiseringsmetode.criiptoOpenId))
            this.visAktiverCriiptodialog = true;
        else
            this.visCriiptodialog = true;

        this.metodeValgt = true;
    }

    autentiseringsmetodernavn(metoder: l.Autentiseringsmetode[]) {
        return metoder.map(metode => this.autentisering.autentiseringsmetodenavn(metode)).join(', ')
    }

    tokenvarighet() {
        this.kontekst.aktivtTokenInfo().tokenvarighet
    }

    /** Kalles når totp er aktivert og reservekodevisningen har blitt lukket av bruker.
     * Må da vise innloggingsdialogen. */
    totpAktivert() {
        this.visAktiverTotpDialog = false;
        this.visPassorddialog = true;
    }

    /** Kalles når smsOtp er aktivert og reservekodevisningen har blitt lukket av bruker.
     * Må da vise innloggingsdialogen. */
    smsOtpAktivert() {
        this.visAktiverSmsOtpDialog = false;
        this.visPassorddialog = true;
    }

    vedCriiptoAvbrutt() {
        this.initMuligeAutentiseringsmetoder();
        this.visCriiptodialog = false;
        this.visPassorddialog = false;
    }

    /** Håndterer at criipt-autentiserings-prosessen konkluderer med at ingen bruker er knyttet til e-iden som ble benyttet.
     * Normalt skal dette ikke kunne forekomme da vi i aktiverCriiptodialog sjekker om bruker har aktivert e-id.
     * Kan dog skje dersom bruker velger en annen e-id tilbyder i criipto-dialogen enn den vedkommende har knyttet brukeren sin til*/
    vedCriiptoBrukerIkkeFunnet(subject) {
        this.$log.warn(`AutentiserMedHøyereSikkerhetsnivåKontroller.vedCriiptoBrukerIkkeFunnet: eid med subject: ${subject} ikke bundet til noen bruker`)
        this.meldingTilBruker.feilmelding(this.gettextCatalog.getString('BankID-en du benyttet er ikke tilknyttet noen bruker i Styreplan3 - kan du ha benyttet feil BankID?'), Varighet.sideskift);
        this.avbryt();
    }

    vedCriiptoFeil(feil: any) {
        this.meldingTilBruker.feilmelding(this.gettextCatalog.getString('En feil oppstod under BankID-autentisering: {{feil}}', {feil: feil}), Varighet.sideskift);
        this.avbryt();
    }

    autentisert(autentisert: l.AutentisertOkModell) {
        this.kontekst.relastBrukerOgGrupper();
        //dersom bruker står på grupper-siden må GruppeDatatjeneste gis tilgang til de nye gruppene..
        //dette ble tidligere håndtert ved at GrupperKontroller lyttet til brukerRelastetEvent og lastet gruppeoversikten på nytt
        //etter migrering av grupper til ng2 lytter ikke lenger grupper-siden til denne eventet (fordi det ville føre til unødvendige mange lastinger av gruppedata)
        //sørger derfor her for å oppdatere GruppeDatatjeneste
        this.gruppeDatatjeneste.tjeneste().then(gruppeDatatjeneste => gruppeDatatjeneste.oppdaterTilgjengeligeGrupper());
        this.$mdDialog.hide();
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit() {
        this.grupper = this.kontekst.grupperSomKreverAnnenAutentiseringsmetode()
        this.initMuligeAutentiseringsmetoder();
    }

    $onDestroy(): void {
    }

    //private hjelpemetoder

    private initMuligeAutentiseringsmetoder() {
        this.tillatteMetoder = _(this.kontekst.grupperSomKreverAnnenAutentiseringsmetode())
            .flatMap(info => info.tillatteMetoder)
            .uniq();
        this.aktiverteMetoder = _(this.kontekst.autentisertBruker().autentiseringsmetoder);

        this.visCriiptovalg = this.tillatteMetoder.includes(l.Autentiseringsmetode.criiptoOpenId);
        this.visPassordvalg = this.tillatteMetoder.includes(l.Autentiseringsmetode.totpOtp) || this.tillatteMetoder.includes(l.Autentiseringsmetode.smsOtp);
    }
}
